<template>
  <div class="table-wrap" ref="tableWrap">
  <a-table 
    bordered 
    rowKey="_id" 
    
    :loading="users.loading"
    :data-source="users.value" 
    :columns="columns" 
    :pagination="false"
    :scroll="{ y: tableScrollY }"
  >
    <div class="cell" slot="username" slot-scope="text, record">
      {{text}} <span class="secondary-text" v-if="isCurrent(record._id)">( Current User )</span>
    </div>
    <div class="cell-button" slot="action" slot-scope="text, record">
      <a-popconfirm
        v-if="!isCurrent(record._id)"
        title="Delete this account and its conversions?"
        okText="Delete"
        okType="danger"
        @confirm="() => removeUser(record)"
      >
        <a-button 
        :loading="record.loading" type="danger" icon="delete"/>
      </a-popconfirm>
    </div>
  </a-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
        columns: [
            {
              title: 'Account Name',
              dataIndex: 'username',
              scopedSlots: { customRender: 'username' },
            },
            {
              title: 'Role',
              dataIndex: 'role',
            },
            {
              title: 'Action',
              align:'center',
              width:'72px',
              scopedSlots: { customRender: 'action' },
            },
        ],
        // body height of the table: the wrapper's height minus the fixed header
        // (same approach as the archive table), so long user lists scroll
        tableScrollY: 400,
        };
    },
    computed: {
        ...mapState('users', ['users']),
        ...mapState('auth', ['userId']),
    },
    methods: {
      ...mapActions('users',['deleteUser']),

      isCurrent(id){
        return this.userId === id
      },

      recomputeScrollY() {
        this.$nextTick(() => {
          const wrap = this.$refs.tableWrap;
          if (!wrap) return;
          const header = wrap.querySelector(".ant-table-header");
          const headerH = header ? header.offsetHeight : 0;
          this.tableScrollY = Math.max(160, wrap.clientHeight - headerH - 2); // 2px: bordered frame
        });
      },

      async removeUser(record) {
        try {
          await this.deleteUser(record._id);
          this.$message.success(`Account "${record.username}" deleted`);
        } catch (error) {
          const reason = error?.response?.data || error?.message || error;
          this.$message.error(`Could not delete "${record.username}": ${reason}`);
        }
      },

    },

    mounted() {
      this.$nextTick(() => this.recomputeScrollY());
      const wrap = this.$refs.tableWrap;
      if (window.ResizeObserver && wrap) {
        this._ro = new ResizeObserver(() => this.recomputeScrollY());
        this._ro.observe(wrap);
      }
      window.addEventListener("resize", this.recomputeScrollY);
      this.$watch(
        () => [this.users.loading, (this.users.value || []).length],
        () => this.recomputeScrollY(),
      );
    },

    beforeDestroy() {
      if (this._ro) this._ro.disconnect();
      window.removeEventListener("resize", this.recomputeScrollY);
    },
}
</script>

<style lang="scss" scoped>
.table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
::v-deep .ant-table-wrapper {
  flex: 1;
  min-height: 0;
}
.cell{
  display: flex;
  align-items: center;
  // justify-content: space-between;
  .secondary-text{
    margin-left: 16px;
    font-style: italic;
    font-size: 0.75rem;
    color: dimgray;
  }
  .cell-button{
    justify-content:center;
  }
}
</style>